import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { PasswordFormComponent } from "@shared/components/password-form/password-form.component";
import { PopupPasswordTemplateComponent } from "@shared/components/popup-password-template/popup-password-template.component";
import { EMAIL, RESET_CODE } from "@shared/constants/route-variables.constants";
import { AUTHENTIFICATION_FORTE, PAGE_NON_TROUVEE } from "@shared/constants/route.constants";
import { AuthenticationService } from "@shared/services/authentication.service";
import { MembersService } from "@shared/services/members.service";
import { switchMap } from "rxjs";

@Component({
  selector: "app-password-init",
  standalone: true,
  imports: [CommonModule, PasswordFormComponent, TranslateModule, PopupPasswordTemplateComponent],
  templateUrl: "./password-init.component.html",
})
export class PasswordInitComponent implements OnInit {
  showPasswordInit = false;
  email: string | undefined;
  resetCode: string | undefined;

  constructor(
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    private memberService: MembersService
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.email = params.get(EMAIL)!;
      this.resetCode = params.get(RESET_CODE)!;
      if (!this.email || !this.resetCode) {
        this.router.navigate([PAGE_NON_TROUVEE]);
      }
      this.showPasswordInit = true;
    });
  }

  onPasswordSubmit(newPassword: string) {
    if (this.email && this.resetCode) {
      this.authenticationService
        .setPassword(this.email, this.resetCode, newPassword)
        .pipe(switchMap(() => this.memberService.updateEnrollmentStatus(this.email!, newPassword, true)))
        .subscribe(() => {
          localStorage.setItem(EMAIL, this.email!);
          this.authenticationService.sendToken(this.email!).subscribe({
            next: () => {
              this.authenticationService.sharedEmail(this.email!);
              this.authenticationService.sharedPassword(newPassword);
              this.router.navigate([AUTHENTIFICATION_FORTE]);
            },
          });
        });
    }
  }
}
